import Vue from 'vue'
import VueRouter from 'vue-router'
import BSSetGreet from '@/views/BOSS/GreetJob.vue'
import LPSetGreet from '@/views/Liepin/GreetJob.vue'
import ZLSetGreet from '@/views/Zhilian/GreetJob.vue'
import LogView from '@/views/LogView.vue'
import LoginView from '@/views/LoginView.vue'
import Assistant from '@/views/Assistant.vue'

Vue.use(VueRouter);
// Vue Router 3 会将重复跳转作为 Promise rejection 抛出（如再次跳转到 /login）。
// 统一吞掉这类无害异常，其他导航错误仍正常抛出，避免页面交互产生未处理异常。
['push', 'replace'].forEach(method => {
  const originalNavigate = VueRouter.prototype[method]
  VueRouter.prototype[method] = function navigate(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalNavigate.call(this, location, onResolve, onReject)
    }
    return originalNavigate.call(this, location).catch(error => {
      if (error && error.name === 'NavigationDuplicated') return error
      return Promise.reject(error)
    })
  }
})

const routes = [
  {
    path: '/assistant', name: 'assistant', component: Assistant,
    meta: {
      title: '智猎AI招聘助手'
    },
    children: [
      // 渠道设置页：/boss/greet、/liepin/chat、/zhilian/rechat ...
      { path: '/:channel(boss)/:type(greet)', component: BSSetGreet },
      { path: '/:channel(liepin)/:type(greet)', component: LPSetGreet },
      { path: '/:channel(zhilian)/:type(greet)', component: ZLSetGreet },
      { path: '/ats', },
      { path: '/log', name: 'log', component: LogView },
    ]
  },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/', redirect: '/login' },
]

const router = new VueRouter({
  routes
})
// 设置页面标题
function setPageTitle(to, from, next) {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '智猎AI专注一站式招聘服务'; // 可选的默认标题
  }
  next();
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  setPageTitle(to, from, next);
});
export default router
